import { AbstractControl, ValidatorFn } from '@angular/forms';
import { GeoTargetingForm } from './geo-targeting.models';

export const MAX_ZIP_CODES = 2000;

export const validateZipCodeCharacters = (zipCodes: string[]): { specialCharsErrorMsg: boolean } | null => {
  const isStringValid = zipCodes.every((value: string) => {
    if (!value) {
      return false;
    }
    if (value.trim() === '') {
      return false;
    }
    if (value === 'null') {
      return false;
    }
    return /^[a-zA-Z0-9- ]+$/.test(value);
  });
  return !isStringValid ? { specialCharsErrorMsg: true } : null;
};

export const validateZipCodeCount = (zipCodes: string[]): { maxZipCodesExceeded: { max: number; actual: number } } | null =>
  zipCodes.length > MAX_ZIP_CODES ? { maxZipCodesExceeded: { max: MAX_ZIP_CODES, actual: zipCodes.length } } : null;


export const extractZipCodes = (control: AbstractControl<GeoTargetingForm>): string[] | null => {
  if (!control) return null;

  const geoTargeting = control.value;
  const zipCodes = geoTargeting?.zipCodesClusiveList?.items;

  if (!zipCodes || !Array.isArray(zipCodes)) {
    return null;
  }

  return zipCodes;
};


export const geoTargetingValidator: ValidatorFn = (control: AbstractControl<GeoTargetingForm>): { [key: string]: any } | null => {
  let errors: { [key: string]: any } | null = null;

  const zipCodes = extractZipCodes(control);

  if (zipCodes && zipCodes.length > 0) {
    const characterValidationError = validateZipCodeCharacters(zipCodes);
    if (characterValidationError) {
      errors = { ...errors, ...characterValidationError };
    }

    const countValidationError = validateZipCodeCount(zipCodes);
    if (countValidationError) {
      errors = { ...errors, ...countValidationError };
    }
  }

  return errors;
};

export const forbiddenCharValidator: ValidatorFn = (control: AbstractControl<GeoTargetingForm>): { [key: string]: any } | null => {
  const zipCodes = extractZipCodes(control);

  if (!zipCodes) {
    return null;
  }

  return validateZipCodeCharacters(zipCodes);
};
